(() => {
  function mount(root) {
    if (root.dataset.ixReady) return;
    root.dataset.ixReady = 'true';
    const groups = JSON.parse(root.querySelector('[data-ix-products]').textContent);
    const labels = JSON.parse(root.querySelector('[data-ix-labels]').textContent);
    const cards = [...root.querySelectorAll('[data-ix-card]')];
    const search = root.querySelector('[data-ix-search]');
    const stock = root.querySelector('[data-ix-stock-filter]');
    const count = root.querySelector('[data-ix-count]');
    const suffix = count.textContent.replace(/^\d+\s*/, '');
    let category = 'all', format = '';
    const normalise = value => value.toLocaleLowerCase('tr').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g,'i');
    function filter() {
      const term = normalise(search.value.trim());
      let visible = 0;
      cards.forEach(card => {
        const matches = groups[Number(card.dataset.ixGroup)].some(v => normalise(v.name+' '+v.color+' '+v.sku).includes(term));
        card.hidden = !(matches && (category === 'all' || card.dataset.ixKind === category) && (!format || card.dataset.ixFormat === format) && (!stock.checked || card.dataset.ixStock === 'true'));
        if (!card.hidden) visible++;
      });
      count.textContent = visible + ' ' + suffix;
      root.querySelector('[data-ix-empty]').hidden = visible > 0;
      const emptyEnquire = root.querySelector('[data-ix-empty-enquire]');
      if (emptyEnquire) {
        const enquiry = 'Merhaba, Instax '+(format ? format.toUpperCase()+' film' : search.value.trim() || 'ürünü')+' için güncel fiyat ve bulunabilirlik bilgisi alabilir miyim?';
        emptyEnquire.href = 'https://wa.me/905391074497?text='+encodeURIComponent(enquiry);
      }
      root.querySelectorAll('[data-ix-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ixCategory === category)));
      root.querySelectorAll('[data-ix-format-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ixFormatChoice === format)));
    }
    function selectFilm(value) {
      category = 'film'; format = value; search.value = ''; stock.checked = false; filter();
      root.querySelector('.ix-toolbar').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    }
    root.addEventListener('click', event => {
      const categoryButton = event.target.closest('[data-ix-category]');
      if (categoryButton) {category = categoryButton.dataset.ixCategory; format = ''; filter();}
      const reset = event.target.closest('[data-ix-reset]');
      if (reset) {category = 'all'; format = ''; search.value = ''; stock.checked = false; filter();}
      const film = event.target.closest('[data-ix-film],[data-ix-format-choice]');
      if (film) selectFilm(film.dataset.ixFilm || film.dataset.ixFormatChoice);
      const button = event.target.closest('[data-ix-variant]');
      if (!button) return;
      const card = button.closest('[data-ix-card]');
      const variant = groups[Number(card.dataset.ixGroup)][Number(button.dataset.ixVariant)];
      const image = card.querySelector('[data-ix-image]');
      image.src = variant.cdn + (variant.cdn.includes('?')?'&':'?')+'width=640'; image.alt = variant.name;
      card.querySelectorAll('[data-ix-variant]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
      card.querySelector('[data-ix-note]').textContent = labels[variant.note || 'regular'];
      card.querySelector('[data-ix-enquire]').href = 'https://wa.me/905391074497?text='+encodeURIComponent('Merhaba, '+variant.name+(variant.sku?' ('+variant.sku+')':'')+' hakkında güncel fiyat ve stok bilgisi almak istiyorum.');
    });
    search.addEventListener('input', filter); stock.addEventListener('change', filter);
    filter();
  }
  document.querySelectorAll('[data-ix-showroom]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ix-showroom]').forEach(mount));
})();

